import React from "react";
import { Box, Typography } from "@mui/material";
import Banner1 from "../images/g5.jpeg";
import Banner2 from "../images/top2.jpeg";
// import Banner3 from "../images/banner3.jpg";
import Image1 from "../images/shopp.jpg";
import Image2 from "../images/g2.jpeg";

function AboutUs() {
  return (
    <>
      {/* Header */}
      <Box 
  sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
          mb: 4,
          mt: 2,
    
  }}
>
  <Typography
    variant="h3"
    style={{
      fontFamily: "SangBleu Empire Trial",
      fontWeight: "bold",
      fontSize: "55px",
      lineHeight: "1",
      display: "inline-block",
    }}
    sx={{ mx: 2 }} // Add space on both sides of the text
  >
    About Us
  </Typography>
  <Box
    sx={{
      width: '38px', // Length of the line
      height: '5px', // Thickness of the line
            backgroundColor: '#FF0000', // Color of the line
      mt:5,
    }}
  />
</Box>






      {/* Main Grid Container */}
      <Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr", // Single column for mobile
      md: "8fr 4fr", // Two columns for medium screens and above
    },
    gap: 2,
    mx: { xs: 2, md: 8 }, // Adjust margins for mobile and larger devices
    height: { xs: "auto", md: "100vh" }, // Auto height for mobile, fixed for larger screens
  }}
>
  {/* Left Grid Item */}
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    {/* First Image */}
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        height: { xs: "200px", md: "41%" },
        "&:hover > .hoverContent": {
          opacity: 1, // Show text on hover
        },
      }}
    >
      <Box
        component="img"
        src={Image1}
        alt="Shopping Complex"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        className="hoverContent"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          color: "white",
          // padding: 2,
          fontSize: { xs: "1rem", md: "1.2rem" },
          fontWeight: "bold",
          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.8)",
          backgroundColor: "rgba(0, 0, 0, 0.7)", // Slightly darker background
          opacity: 0, // Hidden by default
          transition: "opacity 0.3s ease-in-out",
          textAlign: "left", 
          px: 16,
          py: 2, 
          fontFamily: "SangBleu Empire Trial",
        }}
      >
        <Box>Shopping Complex</Box>
        <small
          sx={{
            fontWeight: "lighter",
            fontSize: { xs: "0.8rem", md: "0.8rem" },
          }}
        >
          Hotel City Plaza International is the best Residential Hotel in
          Jessore, Bangladesh. Locating in the center of the city.
        </small>
      </Box>
    </Box>

    {/* Second Image */}
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        height: { xs: "150px", md: "18%" },
        "&:hover > .hoverContent": {
          opacity: 1, // Show text on hover
        },
      }}
    >
      <Box
        component="img"
        src={Banner1}
        alt="Conference Hall"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        className="hoverContent"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          color: "white",
          padding: 2,
          fontSize: { xs: "1rem", md: "1.2rem" },
          fontWeight: "bold",
          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.8)",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          opacity: 0,
          transition: "opacity 0.3s ease-in-out",
          textAlign: "left", 
          px: 16,
          py: 2, 
          fontFamily: "SangBleu Empire Trial",
        }}
      >
        <Box>Conference Hall</Box>
        {/* <small
          sx={{
            fontWeight: "normal",
            fontSize: { xs: "0.8rem", md: "1rem" },
          }}
        >
          Hotel City Plaza International is the best Residential Hotel in
          Jessore, Bangladesh. Locating in the center of the city.
        </small> */}
      </Box>
    </Box>
  </Box>

  {/* Right Grid Item */}
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    {/* Third Image */}
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        height: { xs: "200px", md: "41%" },
        "&:hover > .hoverContent": {
          opacity: 1, // Show text on hover
        },
      }}
    >
      <Box
        component="img"
        src={Image2}
        alt="Play Zone"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        className="hoverContent"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          color: "white",
          // padding: 2,
          
          fontSize: { xs: "1rem", md: "1.2rem" },
          fontWeight: "bold",
          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.8)",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          opacity: 0,
          transition: "opacity 0.3s ease-in-out",
          textAlign: "left", 
          px: 6,
          py: 2, 
          fontFamily: "SangBleu Empire Trial",
        }}
      >
        <Box>Play Zone</Box>
        <small
          sx={{
            fontWeight: "normal",
            fontSize: { xs: "0.8rem", md: "1rem" },
          }}
        >
          Hotel City Plaza International 
        </small>
      </Box>
    </Box>

    {/* Fourth Image */}
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        height: { xs: "150px", md: "18%" },
        "&:hover > .hoverContent": {
          opacity: 1, // Show text on hover
        },
      }}
    >
      <Box
        component="img"
        src={Banner2}
        alt="Rooftop Garden Barbecue Restaurant"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        className="hoverContent"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          color: "white",
          padding: 2,
          fontSize: { xs: "1rem", md: "1.2rem" },
          fontWeight: "bold",
          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.8)",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          opacity: 0,
          transition: "opacity 0.3s ease-in-out",
          textAlign: "left", 
          px: 4,
          py: 2, 
          fontFamily: "SangBleu Empire Trial",
        }}
      >
        <Box>Rooftop Garden Barbecue Restaurant</Box>
        {/* <small
          sx={{
            fontWeight: "normal",
            fontSize: { xs: "0.8rem", md: "1rem" },
          }}
        >
          Hotel City Plaza International 
        </small> */}
      </Box>
    </Box>
  </Box>
      </Box>



    </>
  );
}

export default AboutUs;
